import { Requirements } from './Requirements';

export const ServiceSteps = () => (
  <Requirements
    title="Steps"
    singular="Step"
    endpoint="service-steps"
    subtitle="Manage the ordered steps available for lead sources"
    emptyPrompt="Add a step before assigning it to a lead source"
    testId="service-steps"
    communicationMessages
    taskSelection={false}
  />
);
